import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  studentProfile: null, // Holds student profile information
};

const studentsSlice = createSlice({
  name: "students",
  initialState,
  reducers: {
    setStudentProfile: (state, action) => {
      state.studentProfile = action.payload; // Store student profile data
    },
    clearStudentProfile: (state) => {
      state.studentProfile = null; // Clear profile on logout or change
    },
  },
});

export const { setStudentProfile, clearStudentProfile } = studentsSlice.actions;
export default studentsSlice.reducer;
